import {SCHEME_CLOSE_WEBVIEW} from '../../../../common/constant';
import {requestContext} from '../../../../common/requestContext';

export function closeCreditRefund() {
  window.location.assign(
    requestContext.requestInfo.display.isWebView
      ? SCHEME_CLOSE_WEBVIEW
      : '/support'
  );
}
